<template>
    <div>
        <v-overlay :value="isProcessing">
            <v-progress-circular
                indeterminate
                color="primary"
                :size="70"
                :width="7"
            />
        </v-overlay>
        <v-row justify="center">
            <v-col class="parent-verification" lg="6" md="6" sm="10">
                <h1 id="title">Parental Verification</h1>
                <p>Please read and agree to the following Parental Verification Statements to continue creating your Junior user account.</p>

                <div class="checkbox-container">
                    <input type="checkbox" id="affirm" v-model="affirm" />
                    <label for="affirm"> I(we) affirm I(we) am/are the custodial parent(s) or legal guardian(s) of the recorded owner/minor listed above, and posses full legal power and authority to make this authorization and I(we) accept responsibility to act on behalf of the minor.</label>
                </div>
                <div class="checkbox-container">
                    <input type="checkbox" id="acknowledgeSignature" v-model="acknowledgeSignature" />
                    <label for="acknowledgeSignature"> I(we) acknowledge and agree the signature of any one authorized person, with or without the signature of the minor, will be sufficient to transact business with ASCA on behalf of this recorded owner.</label>
                </div>
                <div class="checkbox-container">
                    <input type="checkbox" id="agreeToAuthorize" v-model="agreeToAuthorize" />
                    <label for="agreeToAuthorize"> I(we) agree that this authorization will become effective upon receipt by ASCA and will remain in effect until a written notice of change or recovation is received by ASCA.</label>
                </div>
                <div class="checkbox-container">
                    <input type="checkbox" id="acknowledgeExpiration" v-model="acknowledgeExpiration" />
                    <label for="acknowledgeExpiration"> I(we) acknowledge the authorization expires on the minor's 16th birthday.</label>
                </div>
                <v-btn
                    :dark="validAgreements()"
                    large
                    color="primary"
                    v-on:click="submit()"
                    :disabled="!validAgreements()"
                >Next</v-btn>
                <div class="footer-container">
                    <v-img height="2rem" contain :src="logo" />
                    <footer-text />
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import FooterText from '@/components/common/FooterText.vue';
import authenticationService from '@/services/authenticationService';

const logo = require('@/assets/logo.svg');

export default Vue.extend({
    components: { FooterText },
    name: 'ParentVerification',
    data() {
        return {
            logo,
            isProcessing: false,
            affirm: false,
            acknowledgeSignature: false,
            agreeToAuthorize: false,
            acknowledgeExpiration: false,
        };
    },
    methods: {
        submit: async function() {
            this.isProcessing = true;

            const juniorData = await authenticationService.getBasicJuniorData(this.$route.query.juniorId);

            this.$store.commit('changeParentVerification', {
                parentId: this.$route.query.parentId,
                juniorId: this.$route.query.juniorId,
                firstName: juniorData.firstName,
                lastName: juniorData.lastName,
                phone: juniorData.phone,
                email: juniorData.email,
                affirm: this.affirm,
                acknowledgeSignature: this.acknowledgeSignature,
                agreeToAuthorize: this.agreeToAuthorize,
                acknowledgeExpiration: this.acknowledgeExpiration,
            });

            this.isProcessing = false;
            this.$router.push('/agreements');
        },
        validAgreements() {
            return !!this.affirm
                && !!this.acknowledgeSignature
                && !!this.agreeToAuthorize
                && !!this.acknowledgeExpiration;
        },
    }
});
</script>